import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { getCurrentInstance, reactive, ref,onMounted } from 'vue'
import { useRoute, useRouter} from 'vue-router'
import { useStore } from '@/store'
import Pagination from '@/components/Pagination.vue'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import SelectBrand from '@/components/SelectBrand.vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'ReconciliationList',
  setup(__props) {

const store = useStore()
const { proxy } = getCurrentInstance() as any
const router = useRouter()
const route = useRoute()
const userType = store.state.user.userInfo.user_type

const pageType:any = route.meta.title   // 当前页面类型
const filters = reactive({
    brand_id:'',                //品牌
    // man_id:   '',           // 厂商ID
    channel_date:'',        //月份
    status:'',              //账单状态
    invoice_status:'',      //发票状态
    fk_status:'',           //结算状态
    invoice_start_time:'',   //收票开始日期
    invoice_end_time:'',     //收票结束日期
    dz_start_time:'',      //对账开始日期
    dz_end_time:'',        //对账结束日期
    fk_start_time:'',      //付款开始日期
    fk_end_time:'',        //付款结束日期
    page:       1,
    page_size:  10,
})
const state = reactive({
    dateList:       [],
    dialogShow:     false,
})
const adjustment = reactive({
    id:'',
    sg_amount:'',//手工调整金额
    sg_reson:'',//调整原因
})
// 获取列表
const tableData = ref([])
const total = ref(0)
//手工调整弹窗
const adjustmentDialog = (row) => {
    adjustment.id = row.id
    state.dialogShow = true    

}
//手工调整
const onReject = () => {
    proxy.$refs['adjustmentForm'].validate((valid:boolean) => {
            if (valid) {
                proxy.$http.post('/channel/do_brand_couponamount', adjustment).then(res => {
                    const { code, data, msg } = res
                    if (code == 200) {
                        proxy.$message({ type: 'success', message: msg }) 
                        beforeDialogClose()
                        getList()
                    } else {
                        proxy.$message({ type: 'error', message: msg }) 
                    }
                })
        }
    })
}
//对账
const toReconciliation = (row) => {
        proxy.$confirm(`是否确认对账`, '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/channel/brand_dz', {id:row.id}).then(res => {
                const { code, data, msg } = res
                if (code == 200) {
                    proxy.$message({ type: 'success', message: msg }) 
                    beforeDialogClose()
                    getList()
                } else {
                    proxy.$message({ type: 'error', message: msg }) 
                }
            })
        }).catch(() => {
            console.log('取消')
        })   
}
// 获取列表数据
const getList = () => {
    proxy.$http.get('/channel/getBrandCouponOrder', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        tableData.value = data.data
        total.value = data.total
    })
}
//获取月份日期
const getDateList = () => {
    proxy.$http.get('/cake_api/getDateList', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        state.dateList = data
    })
}
//导出
const onExport = (type) => {
    window.open(`${Keys.baseUrl}/channel/getBrandCouponOrder?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&is_export=${type}`)
}

// 查看对账详情
const toDetail = (row) => {
    // const { type, city_id, brand_id, rule_id, city_name } = row
    router.push(userType ==2?`/merchant-admin/shop_reconciliation-detail?id=${row.id}`:`/invoice/shop_reconciliation-detail?id=${row.id}`)
}
// 关闭弹框前清空数据
const beforeDialogClose = () => {
    state.dialogShow = false 
    adjustment.id = ''
    adjustment.sg_amount = ''   
    adjustment.sg_reson = ''   

}
const adjustmentRules = reactive ({
    sg_amount: [
        { required: true, message: '请填写金额', trigger: 'blur' }
    ],
    sg_reson: [
        { required: true, message: '请填写调整原因', trigger: 'blur' }
    ]
})

/** 批量上传付款时间 -- begin **/
const dialogVisibleNew = ref(false)
const uploadRef = ref()
//打开上传更新弹窗
const openDialogNew = () => {
    dialogVisibleNew.value = true
}
// 关闭上传更新弹框
const dialogBeforeCloseNew = () => {
    //清除数据
    if(uploadRef.value){
        uploadRef.value!.clearFiles()
    }
    dialogVisibleNew.value = false
}
//确定上传
const dialogSubmit= () => {
    proxy.$refs.uploadRef.submit()
}
const onUploadSuccess= async (res) => {
    const { code, data, msg } = res
    if(code == 200) {
        proxy.$message({ type: 'success', message: msg })
        dialogBeforeCloseNew()
    } else {
        return proxy.$message({ type: 'error', message: msg })
    }
}
/** 批量上传付款时间 -- end **/

const onBrandChange = (val) => {
    filters.brand_id = val
}
const search = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onMounted(() => {
    getList()
    getDateList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, {
        ifBody: 2,
        onBrandChange: onBrandChange
      }),
      _createVNode(_component_el_select, {
        class: "filter-item",
        style: {"width":"150px"},
        modelValue: filters.channel_date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.channel_date) = $event)),
        clearable: "",
        placeholder: "时间（月份）"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dateList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.value,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "账单状态",
        clearable: "",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "未对账",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "对账完成",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.invoice_status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.invoice_status) = $event)),
        placeholder: "发票状态",
        clearable: "",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待提交",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "审核中",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "审核通过",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: "3"
          }),
          _createVNode(_component_el_option, {
            label: "已收票",
            value: "4"
          }),
          _createVNode(_component_el_option, {
            label: "已付款",
            value: "5"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.fk_status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.fk_status) = $event)),
        placeholder: "结算状态",
        clearable: "",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "未结算",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "已结算",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.invoice_start_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.invoice_start_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.invoice_end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.invoice_end_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.dz_start_time,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.dz_start_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "对账开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.dz_end_time,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.dz_end_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "对账结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.fk_start_time,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.fk_start_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "付款开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.fk_end_time,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.fk_end_time) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "付款结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openDialogNew
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode("批量上传付款时间")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (onExport(3)))
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: "账单月份"
        }),
        _createVNode(_component_el_table_column, {
          prop: "orderMoney",
          label: "订单总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "jiesuan_amount",
          label: "实际结算总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_text",
          label: "账单状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "dz_time",
          label: "对账时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_text",
          label: "发票状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_time",
          label: "收票时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "fk_text",
          label: "结算状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "fk_time",
          label: "付款时间",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_tag, {
                size: "small",
                onClick: ($event: any) => (toDetail(scope.row))
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_tag, {
                size: "small",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (onExport(1)))
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              }),
              (_unref(userType) ==2 && scope.row.status == 0)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "small",
                    disabled: scope.row.status == 1,
                    onClick: ($event: any) => (toReconciliation(scope.row))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("对账")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(userType)!==2 && scope.row.invoice_status != 2)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    size: "small",
                    onClick: ($event: any) => (adjustmentDialog(scope.row))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("手工调整")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "手工调整",
      modelValue: state.dialogShow,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.dialogShow) = $event)),
      "before-close": beforeDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeDialogClose }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onReject
        }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "120px",
          model: adjustment,
          rules: adjustmentRules,
          ref: "adjustmentForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "金额",
              prop: "sg_amount",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: adjustment.sg_amount,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((adjustment.sg_amount) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "调整原因",
              prop: "sg_reson",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 5,
                  maxlength: "150",
                  "show-word-limit": "",
                  modelValue: adjustment.sg_reson,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((adjustment.sg_reson) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传付款时间",
      modelValue: dialogVisibleNew.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dialogVisibleNew).value = $event)),
      "before-close": dialogBeforeCloseNew
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeCloseNew }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: `/api/channel/do_invoice_pay?user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}&ship_type=2`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/invoice/downLoad_invoicepay_excel`
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("下载上传模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})